import { string } from 'yup';

const BLOCK_TAGS = new Set(['P', 'DIV', 'H1', 'H2', 'H3', 'H4', 'BLOCKQUOTE', 'LI', 'UL', 'OL']);

const escapeHtml = (text: string) =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

export const plainTextToHtml = (text: string | null | undefined): string =>
  (text ?? '')
    .split(/\n{2,}/)
    .filter((paragraph) => paragraph.trim())
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br>')}</p>`)
    .join('');

export const htmlToPlainText = (html: string | null | undefined): string => {
  if (!html) return '';
  const { body } = new DOMParser().parseFromString(html, 'text/html');
  const blocks: string[] = [];
  let current = '';

  const walk = (node: Node) => {
    node.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        current += child.textContent ?? '';
      } else if (child.nodeName === 'BR') {
        current += '\n';
      } else if (BLOCK_TAGS.has(child.nodeName)) {
        if (current.trim()) blocks.push(current.trim());
        current = '';
        walk(child);
        if (current.trim()) blocks.push(current.trim());
        current = '';
      } else {
        walk(child);
      }
    });
  };

  walk(body);
  if (current.trim()) blocks.push(current.trim());
  return blocks
    .join('\n\n')
    .replace(/\u00a0/g, ' ')
    .replace(/[ \t]+\n/g, '\n');
};

export const initialRichText = (html: string | null | undefined, plainText: string | null | undefined): string =>
  html ?? plainTextToHtml(plainText);

export const richTextSchema = (requiredMessage?: string) => {
  const schema = string().default('');
  return requiredMessage
    ? schema.test('has-text', requiredMessage, (value) => htmlToPlainText(value).trim().length > 0)
    : schema;
};

export const richTextFields = (html: string) => ({ content: htmlToPlainText(html), contentHtml: html });
